export const formErrorMessages = {
    required: 'Обязательное поле',
    password: 'Минимум 8 символов',
    passwordRepeat: 'Пароли не совпадают',
    email: 'Некорректный email'
};

export const apiErrorsDictionary = {
    'The email has already been taken.': 'Email адрес уже зарегистрирован',
    'validation.unique': 'Email адрес уже зарегистрирован',
    'The email field is required.': 'Укажите электронную почту'
};
